import React, { Component } from "react";
import { connect } from "react-redux";
import projActions from "../../../_actions/projActions";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import _ from "lodash";
import Select from "react-select";
import AlertModal from "../../_common/AlertModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import unitActions from "../../../_actions/unitActions";
import distOptions from "../../../_constants/distOptions";
import MultiselectTable from "../../_common/MultiselectTable";
import { docPermConstants } from "../../../_constants/permissionConstants";
import "./styles/projAssignment.css";

class EditProjUnitsModal extends Component {
  state = {
    distFilter: null,
    unitFilter: "",
    selectedUnits: [],
    deletedUnits: [],
    unitIdToUnassign: 0,
    showAlert_cancel: false,
    showAlert_puUnassignWarn: false,
    sortColumn: { path: "distUnit", order: "asc" },
    error: null,
  };

  columns = [
    { path: "distUnit", label: "Dist-Unit", isSortable: true },
    {
      path: "unitManagerFullName",
      label: "Unit Mgr",
      isSortable: true,
      content: (unit) => <small>{unit.unitManagerFullName}</small>,
    },
  ];

  componentDidMount() {
    const { projectUnits, user, tabId, dispatch } = this.props;
    const selectedUnits = [...projectUnits];

    dispatch(unitActions.getAll(user.district, tabId)).then(() =>
      this.setState({
        selectedUnits,
        distFilter: distOptions.with59.find((o) => o.value === user.district),
      })
    );
  }

  handleChange_distFilter = (distFilter) => {
    const { dispatch, tabId } = this.props;
    this.setState({ distFilter });
    dispatch(unitActions.getAll(distFilter ? distFilter.value : null, tabId));
  };

  handleChange_unitFilter = (e) => this.setState({ unitFilter: e.target.value });

  handleClick_unassign = (unitId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ unitIdToUnassign: unitId }, this.toggleAlert_puUnassignWarn);
  };

  handleSubmit_editProjectUnits = (e) => {
    e.preventDefault();
    const { dispatch, projectId, toggleEditProjUnitsModal } = this.props;
    let selectedUnits = [...this.state.selectedUnits];
    dispatch(projActions.saveProjectUnits(selectedUnits, projectId)).then(() =>
      toggleEditProjUnitsModal()
    );
  };

  handleClick_cancel = (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
  };
  toggleAlert_cancel = () =>
    this.setState({ showAlert_cancel: !this.state.showAlert_cancel });
  handleAlert_cancel = (actionType) => (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
    if (actionType === "accept") this.props.toggleEditProjUnitsModal();
  };

  toggleAlert_puUnassignWarn = () =>
    this.setState({ showAlert_puUnassignWarn: !this.state.showAlert_puUnassignWarn });
  handleAlert_puUnassignWarn = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept") this.unassignProjectUnit();
    this.toggleAlert_puUnassignWarn();
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleSelect = (unit) => this.assignProjectUnit(unit);
  handleDeselect = (unit) => {
    const { permissions } = this.props;
    if (permissions.includes(docPermConstants.EDIT_LEVEL_2)) {
      this.setState({ unitIdToUnassign: unit.unitId });
      this.toggleAlert_puUnassignWarn();
    }
  };

  assignProjectUnit = (unit) => {
    const { unitList } = this.props;
    // Determine if the unit being added is being 'recovered'
    let deletedUnits = this.state.deletedUnits.map((du) => ({ ...du }));
    let selectedUnits = this.state.selectedUnits.map((su) => ({ ...su }));
    const recoverableUnit = deletedUnits.find((u) => u.unitId === unit.unitId);
    if (recoverableUnit) {
      // Add the recoverable unit back to selectedUnits
      selectedUnits.unshift(recoverableUnit);
      // Then remove it from the recoverable list
      deletedUnits = deletedUnits.filter((u) => u.unitId !== recoverableUnit.unitId);
    } else {
      const unitToAdd = unitList.find((u) => u.unitId === unit.unitId);
      if (unitToAdd) selectedUnits.push(unitToAdd);
    }
    this.setState({
      selectedUnits,
      deletedUnits,
    });
  };

  unassignProjectUnit = () => {
    const { selectedUnits, unitIdToUnassign } = this.state;
    const deletedUnits = this.state.deletedUnits.map((du) => ({ ...du }));
    const unitToDelete = selectedUnits.find((u) => u.unitId === unitIdToUnassign);
    if (unitToDelete) {
      deletedUnits.push(unitToDelete);
      this.setState({
        selectedUnits: selectedUnits.filter((u) => u.unitId !== unitIdToUnassign),
        deletedUnits,
      });
    }
  };

  getData = () => {
    const { unitList } = this.props;
    const { sortColumn, unitFilter } = this.state;
    return _.orderBy(unitList, [sortColumn.path], [sortColumn.order]);
  };

  renderProjectUnits = () => {
    const { selectedUnits } = this.state;
    const { permissions, fetching } = this.props;
    return (
      <div className="card flex-grow-1 bg-lightgray pu-rt">
        <div className="card-body pb-2">
          <h5 className="text-muted">Assigned Units</h5>
          {selectedUnits &&
            selectedUnits.map((u, index) => (
              <div key={`projUnitRow_${index}`} className="card my-2 mx-0">
                <div className="card-body p-2">
                  <div className="d-flex flex-row w-100">
                    <div className="pu-rt__item-head--dist-unit my-auto">
                      <b>{u.distUnit}</b>
                    </div>
                    <div className="pu-rt__item-head--unit-mgr my-auto">
                      Unit Mgr: {u.unitManagerFullName}
                    </div>
                    <div className="pu-rt__item-head--unassign">
                      <div className="float-right">
                        <button
                          name="unassign"
                          id={`unassignBtn_${u.unitId}`}
                          className="btn btn-sm btn-outline-danger p-1"
                          onClick={this.handleClick_unassign(u.unitId)}
                          hidden={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
                          disabled={
                            !permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
                            fetching
                          }
                        >
                          <FontAwesomeIcon icon="times" className="fa-fw" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedUnits,
      deletedUnits,
      distFilter,
      unitFilter,
      sortColumn,
      showAlert_cancel,
      showAlert_puUnassignWarn,
    } = this.state;
    const { fetching, showEditProjUnitsModal, toggleEditProjUnitsModal } = this.props;
    const data = this.getData();
    const closeBtn = (
      <button className="close" onClick={toggleEditProjUnitsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditProjUnitsModal}
          toggle={this.handleClick_cancel}
          className={this.props.className}
          fade={false}
          size={"xl"}
        >
          <ModalHeader
            toggle={this.handleClick_cancel}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            Edit Project Units
          </ModalHeader>
          <ModalBody>
            <div className="d-flex flex-row">
              <div className="d-flex flex-column flex-fill pr-2 left-panel">
                <div className="card flex-grow-1">
                  <div className="card-body">
                    <div className="d-flex flex-row flex-wrap w-100 mb-1 pu-lt-filter">
                      <div className="pu-lt-filter__select--dist pr-2">
                        <Select
                          name="distFilter"
                          id="distFilter"
                          className="align-middle w-100"
                          value={distFilter}
                          options={distOptions.with59}
                          onChange={this.handleChange_distFilter}
                          placeholder="Dist"
                          isSearchable={false}
                          isClearable
                        />
                      </div>
                      <div className="pu-lt-filter__input--unit flex-grow-1">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text bg-lightgray">
                              <FontAwesomeIcon
                                icon="search"
                                className="fa-fw text-muted"
                              />
                            </span>
                          </div>
                          <input
                            name="unitFilter"
                            id="unitFilter"
                            className="form-control"
                            value={unitFilter}
                            onChange={this.handleChange_unitFilter}
                            placeholder="Unit No., or Unit Manager"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 border table-unit-list">
                      <MultiselectTable
                        className="table table-sm table-hover"
                        data={data || []}
                        selectedItems={selectedUnits || []}
                        deletedItems={deletedUnits || []}
                        columns={this.columns}
                        idPropName={"unitId"}
                        onSelect={this.handleSelect}
                        onDeselect={this.handleDeselect}
                        onSort={this.handleSort}
                        sortColumn={sortColumn}
                        showSearch={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-fill right-panel">
                {this.renderProjectUnits()}
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-group form-row form-inline float-right mb-0">
              <button
                type="button"
                name="saveProjAssignments"
                id="saveProjAssignments"
                className="btn btn-primary mr-2"
                onClick={this.handleSubmit_editProjectUnits}
                disabled={fetching}
              >
                {fetching && (
                  <span className="mr-2 mt-1">
                    <FontAwesomeIcon
                      icon="spinner"
                      className="loading-spinner"
                      style={{ color: "white" }}
                    />
                  </span>
                )}
                {`${fetching ? "Saving" : "Save"}`}
              </button>
              <button
                type="button"
                name="cancelProjAssignments"
                id="cancelProjAssignments"
                className="btn btn-secondary"
                onClick={toggleEditProjUnitsModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAlert_cancel && (
          <AlertModal
            alertKey={"cancelEditProjUnitsKey"}
            alertTitle={"Cancel Edit Project Units"}
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to cancel?"
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_cancel}
            showAlertModal={showAlert_cancel}
            toggleAlertModal={this.toggleAlert_cancel}
          />
        )}
        {showAlert_puUnassignWarn && (
          <AlertModal
            alertTitle={"Unassign Unit from Project"}
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={
              `Are you sure you want to unassign this unit?\n\n` +
              `After deleting, any users of this unit who are still assigned to this project will be marked as "On Loan".`
            }
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_puUnassignWarn}
            showAlertModal={showAlert_puUnassignWarn}
            toggleAlertModal={this.toggleAlert_puUnassignWarn}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  unitList: state.users.openUnitLists[ownProps.tabId] || [],
  projectUnits: state.projects.projectUnitLists[ownProps.projectId] || [],
  fetching:
    state.projects.fetching ||
    state.feederLists.fetching ||
    state.users.fetching ||
    state.fieldOffices.fetching,
});

export default connect(mapStateToProps)(EditProjUnitsModal);
